module.exports = __webpack_public_path__ + "static/media/Lens-Vivid_TW.531f190d.png";